module.exports = __webpack_public_path__ + "static/img/page9-bg.2a87c64.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/listen-report/page9-bg.png
// module id = w39j
// module chunks = 215